import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export const SESSION_PROBLEM_TITLE = "Please sign in again";
export const SESSION_PROBLEM_MESSAGE =
  "We couldn't confirm your sign-in. Please sign out, then sign in again. If this keeps happening, contact your Cortica care team.";

interface SessionProblemDialogProps {
  open: boolean;
  onSignOut: () => void;
}

export const SessionProblemDialog = ({ open, onSignOut }: SessionProblemDialogProps) => (
  <Dialog
    open={open}
    aria-labelledby="session-problem-title"
    aria-describedby="session-problem-description"
  >
    <DialogTitle id="session-problem-title">{SESSION_PROBLEM_TITLE}</DialogTitle>
    <DialogContent>
      <DialogContentText id="session-problem-description">
        {SESSION_PROBLEM_MESSAGE}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={onSignOut} autoFocus>
        Sign out
      </Button>
    </DialogActions>
  </Dialog>
);
